export default {
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  label: {
    backgroundColor: '#FFF',
    width: '70vw',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '10px',
    fontSize: '16px',
    fontWeight: '500',
    borderBottom: '1px solid #EBEDF2'
  },

  footer: {
    margin: '15px',
    display: 'flex',
    justifyContent: 'center',
    '& button': {
      marginRight: '10px'
    }
  }
};
